import styled from "styled-components";

type DividerProps = {
  margin?: string;
};

const Divider = styled.hr`
  width: 100%;
  border-top: none;
  border-right: none;
  border-left: none;
  border-image: initial;
  border-bottom: 1px solid ${({ theme }) => theme.dividerColor};
  ${(props: DividerProps) => (props.margin ? `margin: ${props.margin}` : "")}
`;

export default Divider;
